(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    



document.querySelectorAll('[aria-controls="search-drawer"]').forEach((ele)=>{
    ele.addEventListener('click', function(e){
        console.log(e.target);

         if(event.target.getAttribute('id') == 'main_blog__'){
          console.log('if');
              setTimeout(()=>{
          document.querySelector('search-drawer').classList.add('onlyBlog__')
          document.querySelector('#search__both').value='article';
          console.log(document.querySelector('#search__both'))
      },2000);
        }else{
    console.log('else');
 setTimeout(()=>{
       document.querySelector('search-drawer').classList.remove('onlyBlog__')
  },2000);
        }
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-register"]) return;
  try {
    
 (function() { 
let dob = document.querySelector('input[type="date"]');
let phone = document.querySelector('input[type="tel"]');
let check__ = document.querySelectorAll('input[type="checkbox"]');
const subject = document.querySelector('#subject');
phone.addEventListener('input', function(){
    
    if(this.value.length>0 && dob.value.length>0){
     check__.forEach(box=>{
            box.checked=true;
            subject.insertAdjacentHTML('afterbegin', `<input type="hidden" name="customer[tags]" 
              value="SMS_Subscribed">`);
          });
    }else{
      check__.forEach(box=>{
            box.checked=false;
            subject.innerHTML='';
          });
    }
  
 });
dob.addEventListener('input', function(){
    if(this.value.length>0 && phone.value.length>0){
       check__.forEach(box=>{
            box.checked=true;
            subject.insertAdjacentHTML('afterbegin', `<input type="hidden" name="customer[tags]" 
              value="SMS_Subscribed">`);
          });
    }else{
       check__.forEach(box=>{
            box.checked=false;
            subject.innerHTML='';
          });
    }
});
   })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
var url_string = window.location;
var url = new URL(url_string);
var type = url.searchParams.get("type");
var top = document.querySelector('.collection__top-bar');
setTimeout(() => {
  var search_input = document.querySelector('#pick_value');
(type == 'article')?
(search_input.value='article', top.style.display='none'):
(search_input.value='product', top.style.display='block');
console.log(search_input);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    

document.querySelector('[aria-controls="newsletter-popup"]').addEventListener('click',()=>{
  document.querySelector('newsletter-popup').setAttribute('open', '');
  document.querySelector('newsletter-popup').style.visibility='visible';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
